import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { If } from "@componentsShared/Conditional/If";
var FlowOptionBody = function FlowOptionBody(_ref) {
  var imgUrl = _ref.imgUrl,
    name = _ref.name,
    haveBackground = _ref.haveBackground;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 md:flex-col md:justify-center md:w-full"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: haveBackground
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    className: "h-6 w-6 bg-red-600 p-0.5"
  }, /*#__PURE__*/React.createElement("img", {
    src: imgUrl,
    alt: name,
    className: "w-full h-full object-scale-down"
  }))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(If, {
    condition: !!imgUrl
  }, /*#__PURE__*/React.createElement("img", {
    src: imgUrl,
    alt: name,
    width: "24",
    height: "24",
    className: "object-scale-down md:w-10 md:h-10"
  })))), /*#__PURE__*/React.createElement("p", {
    className: "text-start text-black-primary text-sm font-semibold leading-5 md:text-gray-text md:text-base capitalize"
  }, name)), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-back-ios-new-rounded",
    width: 4,
    height: 4,
    className: "md:hidden en:transform en:rotate-180"
  })));
};
export default FlowOptionBody;